module.exports = __webpack_public_path__ + "static/media/9.23c5f926.svg";